import { JandiConfirmDialog } from 'ui-components/JandiConfirmDialog';
import { useAppDispatch, useAppSelector } from 'hooks';
import { dismissAlert, extendSession } from 'store/sessionReducer';

const SessionAlertDialog = () => {
    const dispatch = useAppDispatch();
    const { showAlert, isExtending } = useAppSelector((state) => state.session);

    return (
        <JandiConfirmDialog
            open={showAlert}
            title="Session Expiring"
            confirmLabel={isExtending ? 'Extending...' : 'Extend Session'}
            cancelLabel="Close"
            danger
            onConfirm={() => dispatch(extendSession())}
            onCancel={() => dispatch(dismissAlert())}
        >
            Your session is about to expire. Extend it to keep working.
        </JandiConfirmDialog>
    );
};

export default SessionAlertDialog;
